<app-pub-searcher (onSearchEvent)="hideLogin = $event"></app-pub-searcher>
<app-pub-login [hideLogin]="hideLogin"></app-pub-login>




// WEBPACK FOOTER //
// ./src/app/app-public/pub-home/pub-home.component.html